module.exports = __webpack_public_path__ + "img/lowerabs-ecto-mesomorph-female.96caf132.svg";